import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { SectionModel } from 'entities/section/model/sectionModel';
import EditSectionModal from 'widgets/sections/editSectionModal';
import { UploadedFileOrString } from 'shared/lib/utils/uploadedFileOrString';
import React, { useContext, useState } from 'react';
import DeleteSectionModalController, {
  DeleteSectionModalControllerActions,
} from 'widgets/sections/deleteSectionModalController';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import ErrorModal from 'shared/lib/components/modals/errorModal';

export type EditSectionModalActions = {
  afterSectionUpdate?: (fileModel: SectionModel) => void;
} & DeleteSectionModalControllerActions;

export default observer(function EditSectionModalController({
  sectionModel,
  afterSectionDelete,
  afterSectionUpdate,
  handleClose,
}: {
  sectionModel: SectionModel;
  handleClose: () => void;
} & EditSectionModalActions) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  const [isDublicateError, setIsDublicateError] = useState(false);

  if (!sectionModel.data) {
    return null;
  }

  return (
    <>
      <EditSectionModal
        isOpen={true}
        handleClose={handleClose}
        currentParams={{
          name: sectionModel.data.name,
          image: new UploadedFileOrString(sectionModel.data.image_src),
        }}
        onDelete={() => setIsDeleting(true)}
        onSubmit={async ({ name, image }) => {
          try {
            await sectionModel.update({
              name,
              image_src: image.file ? image.file : undefined,
            });
            afterSectionUpdate && afterSectionUpdate(sectionModel);
            handleClose();
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.SectionExists
            ) {
              setIsDublicateError(true);
              return;
            }

            handleClose();
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
        }}
      ></EditSectionModal>

      {isDeleting && (
        <DeleteSectionModalController
          section={sectionModel}
          handleClose={() => {
            setIsDeleting(false);
            handleClose();
          }}
          afterSectionDelete={afterSectionDelete}
        ></DeleteSectionModalController>
      )}

      {isDublicateError && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setIsDublicateError(false)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Действие невозможно&nbsp;&mdash; раздел с&nbsp;таким названием уже
            существует
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
